
document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('.multi-video-product-slider');
  if (!section) return;

  const popup = document.getElementById('videoPopup1');
  const popupContainer = popup.querySelector('.popup-video-container');
  const popupProduct = popup.querySelector('.popup-product-container');
  const closeBtn = popup.querySelector('.popup-close');

  /* --------------------------------
     AUTOPLAY SHOPIFY VIDEOS IN SLIDER
  -------------------------------- */
  function initInlineVideos() {
    section.querySelectorAll('.video-wrapper video').forEach(video => {
      video.muted = true;
      video.autoplay = true;
      video.loop = true;
      video.playsInline = true;
      video.removeAttribute('controls');

      try { video.play(); } catch (e) {}
    });
  }

  /* --------------------------------
     OPEN POPUP WITH CLONED VIDEO
  -------------------------------- */
  function openPopupWithVideo(videoEl, productHtml) {
    popupContainer.innerHTML = '';
    popupProduct.innerHTML = '';

    const clonedVideo = videoEl.cloneNode(true);
    clonedVideo.muted = false;
    clonedVideo.autoplay = true;
    clonedVideo.controls = false;
    clonedVideo.playsInline = true;
    clonedVideo.currentTime = 0;

    popupContainer.appendChild(clonedVideo);

    if (productHtml) popupProduct.innerHTML = productHtml;

    popup.style.display = 'flex';
    popup.setAttribute('aria-hidden', 'false');

    try { clonedVideo.play(); } catch (e) {}
  }

  /* --------------------------------
     CLICK HANDLING (VIDEO ONLY)
  -------------------------------- */
  section.addEventListener('click', function (e) {
    const video = e.target.closest('.video-wrapper video');
    if (!video) return;

    const card = video.closest('.video-card');
    if (!card) return;

    const productCard = card.querySelector('.product-card-wrap');
    const productHtml = productCard ? productCard.outerHTML : '';

    openPopupWithVideo(video, productHtml);
  });

  /* --------------------------------
     PREVENT POPUP ON PRODUCT CLICK
  -------------------------------- */
  section.querySelectorAll('.product-card-wrap, .terminal-overlay-links').forEach(el => {
    el.addEventListener('click', function (e) {
      e.stopPropagation();
    });
  });

  /* --------------------------------
     POPUP CLOSE
  -------------------------------- */
  function closePopup() {
    popup.style.display = 'none';
    popup.setAttribute('aria-hidden', 'true');
    popupContainer.innerHTML = '';
    popupProduct.innerHTML = '';
  }

  closeBtn.addEventListener('click', closePopup);

  popup.addEventListener('click', function (e) {
    if (e.target === popup) closePopup();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popup.style.display === 'flex') {
      closePopup();
    }
  });

  /* --------------------------------
     SWIPER INIT
  -------------------------------- */
  let swiperInitialized = false;
  function initSwiper() {
    if (swiperInitialized) return;
    swiperInitialized = true;

    new Swiper('.multiVideoSwiper', {
      slidesPerView: 5,
      spaceBetween: 12,
      loop: true,
      autoplay: false,
      speed: 900,
      pagination: { el: '.swiper-pagination', clickable: true, enabled: false },
      navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
      breakpoints: {
        320: { slidesPerView: 1.5, centeredSlides: true },
        768: { slidesPerView: 3 },
        1024: { slidesPerView: 5 }
      }
    });
  }

  /* --------------------------------
     OBSERVER
  -------------------------------- */
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          initInlineVideos();
          initSwiper();
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    observer.observe(section);
  } else {
    initInlineVideos();
    initSwiper();
  }
});

